<div>
  <div class="modal-header">
    <h4 class="modal-title">Add Voice</h4>
    <button
      type="button"
      [disabled]="isUploadDone"
      class="btn-close"
      aria-label="Close"
      (click)="modal.close(true)"
    ></button>
  </div>
  <div class="modal-body">
    <app-voice-form
      [voice]="'voice'"
      (isUploadChangeEvent)="uploadChange($event)"
      (formValidityChangeEvent)="onValidityChange($event)"
    >
    </app-voice-form>
  </div>
  <div class="modal-footer">
    <button
      type="submit"
      [disabled]="isInValid"
      class="btn btn-raised btn-success"
      (click)="submit()"
    >
      <span>
        Add Voice
        <i
          *ngIf="adding$ | async as adding"
          class="fa fa-refresh refreshbtn"
          matSuffix
          [ngClass]="{ 'fa-spin': adding }"
        >
        </i>
      </span>
    </button>
    <button
      type="button"
      [disabled]="isUploadDone"
      class="btn btn-raised btn-secondary me-2"
      (click)="modal.close(true)"
    >
      Close
    </button>
  </div>
</div>
